import { Component } from '@angular/core';
import { CompareFacadeService } from '../../+store/compare/compare.facade';
import { SavedFacadeService } from '../../+store/saved/saved.facade';
import { MatDialog } from '@angular/material/dialog';
import { SavedDialogComponent } from 'src/app/features/saved/components/saved-dialog/saved-dialog.component';

@Component({
  selector: 'tad-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public compare$ = this.compareFacadeService.institutions$;
  public saved$ = this.saveFacadeService.institutions$;
  constructor(
    private compareFacadeService: CompareFacadeService,
    private saveFacadeService: SavedFacadeService,
    private dialog: MatDialog
  ) {}

  public showSaved(): void {
    this.dialog.open(SavedDialogComponent, {
      width: '1100px',
      maxWidth: '98vw',
      maxHeight: '90vh',
      autoFocus: false
    });
  }
}
